import { DotLottieReact } from '@lottiefiles/dotlottie-react';

export const Construction = () => {
  const constructionUrl = new URL('./construction.lottie', import.meta.url).href;

  return (
    <div className="flex h-96 items-center justify-center">
      <DotLottieReact autoplay loop className="h-full w-full" src={constructionUrl} />
    </div>
  );
};
